import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import useCreateEquipmentPiece from "hooks/organization/useCreateEquipmentPiece";
import useModalState from "hooks/useModalState";
import Modal from "modules/Modal/Modal";
import { useCallback } from "react";
import Create from "modules/OrganizationEquipmentPieces/Create";
import MDAlert from "components/MDAlert";
import parseGraphQLError from "utils/graphQL/parseGraphQLError";
import MDTypography from "components/MDTypography";
import { CreateEquipmentPieceInput, EquipmentPieceChargeType } from "generated/graphql";

interface CreateEquipmentPieceModalProps {
  title?: string;
  size?: "small" | "medium" | "large";
  variant?: "text" | "outlined" | "contained" | "gradient";
  startIcon?: React.ReactNode;
}

export default function CreateEquipmentPieceModal({
  title = "Create Equipment Piece",
  size = "medium",
  variant = "gradient",
  startIcon,
}: CreateEquipmentPieceModalProps) {
  const { open, onClose, onOpen } = useModalState();
  const [createEquipmentPiece, { loading, error, isSuccess, getData }] = useCreateEquipmentPiece();

  const onSubmit = useCallback(
    async (input: CreateEquipmentPieceInput) => {
      const result = await createEquipmentPiece({
        variables: {
          input: {
            ...input,
            rate: Math.floor(input.rate * 100),
            fuelSurcharge: Math.floor(input.fuelSurcharge * 100),
          },
        },
      });
      const data = getData(result);
      const success = isSuccess(result.data);
      if (isSuccess) {
        onClose();
      }
      return { success, data };
    },
    [createEquipmentPiece]
  );

  return (
    <>
      <MDButton
        type="button"
        variant={variant}
        color="secondary"
        size={size}
        startIcon={startIcon}
        onClick={onOpen}
      >
        {title}
      </MDButton>
      <Modal open={open} onClose={onClose}>
        <MDTypography variant="h6" p={3}>
          Create Equipment Piece
        </MDTypography>
        {error && <MDAlert>{parseGraphQLError(error)}</MDAlert>}
        <Create onSubmit={onSubmit} loading={loading} />
      </Modal>
    </>
  );
}
